import React from 'react';
import classNames from 'classnames';

export interface SegmentedBarLegendItem {
  key: string;
  label: string;
  color: string;
}

export interface SegmentedBarLegendProps {
  items: SegmentedBarLegendItem[];
  className?: string;
  dataCy?: string;
}

/** A horizontal swatch-and-label legend for SegmentedBar. */
const SegmentedBarLegend: React.FC<SegmentedBarLegendProps> = ({
  items,
  className,
  dataCy = 'segmented-bar-legend',
}) => (
  <ul className={classNames('segmented-bar-legend', className)} data-cy={dataCy}>
    {items.map(({ key, label, color }) => (
      <li key={key} className="segmented-bar-legend-item" data-cy={`${dataCy}-${key}`}>
        <span
          className="segmented-bar-legend-swatch"
          style={{ '--segmented-bar-color': color } as React.CSSProperties}
          aria-hidden="true"
        />
        {label}
      </li>
    ))}
  </ul>
);

export default SegmentedBarLegend;
